import React, { useState, useEffect } from "react";

import backIcon from "../../img/Arrow.png";
import bagIcon from "../../img/bagIcon2.png";
import billIcon from "../../img/summaryIcon.png";
import helpIcon from "../../img/icon-help2.png";
import { useNavigate, useParams } from "react-router";
import CustomerCare from "../Accounts/Components/CustomerCare";
import {
  fetchOrderDetails,
  fetchStoreOrderDetails,
} from "../../Request/OrderRequests";
import { MyOrderCard } from "../Accounts/Components/MyOrder";
// import OrderDetailCard from "./Components/OrderDetailCard";

const PlacedOrderDetails = () => {
  const order_id = useParams().id;
  const navigate = useNavigate();
  const [showHelp, setShowHelp] = useState(false);
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (order_id) {
      fetchOrderDetails(order_id)
        .then((res) => {
          if (!res?.order.length || !res?.suborder?.length) {
            fetchStoreOrderDetails(order_id).then((backupres) => {
              const { order, suborder } = backupres;
              setOrder({ suborder: suborder, order: order[0] });
            });
            return;
          }
          const { order, suborder } = res;
          setOrder({ suborder: suborder, order: order[0] });
        })
        .catch((err) => console.log(err));
    }
  }, [order_id]);

  return order ? (
    <div style={{ background: "#f4f5f7", minHeight: "calc(100vh - 64px)" }}>
      <div
        //   ref={titleBarRef}
        style={{
          padding: "13.5px 16px",
          boxShadow: "0px 1px 0px rgba(0, 0, 0, 0.11)",
        }}
        className="fixed-top d-flex align-items-center transition text-orange bg-white "
      >
        <div className="text-center my-auto" style={{ paddingRight: "8px" }}>
          <img src={backIcon} alt="" width={24} onClick={() => navigate(-1)} />
        </div>
        <div className="w-100 my-auto overflow-hidden">
          <h2
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontSize: "16px",
              margin: "0 0 2px",
              color: "#2b2b2b",
              fontWeight: "700",
            }}
          >
            Order Details
          </h2>
          <h5
            style={{
              fontSize: "12px",
              margin: "0",
              color: "#666666",
              fontWeight: "500",
            }}
          >
            Order ID: #RP{order?.order?.order_id}
          </h5>
        </div>
        <div
          className="d-flex align-items-center justify-content-evenly my-auto ms-auto "
          style={{ paddingLeft: "8px" }}
          onClick={() => setShowHelp(true)}
        >
          <img
            src={helpIcon}
            alt=""
            style={{ marginRight: "4px" }}
            width={20}
            className="d-block"
            // onClick={() => navigate(`/${storeLink}/search`)}
          />
          Help
        </div>
      </div>
      <div
        className="accountOrders-list"
        style={{
          marginTop: "63px",
          background: "#fff",
          borderBottom: "4px solid #f4f5f7",
          padding: "16px",
        }}
      >
        {/* //orderCard */}
        {/* <OrderDetailCard order={order} /> */}
        <MyOrderCard order={order?.order} />
      </div>

      <div
        className="card-wrap"
        style={{
          background: "#fff",
          borderBottom: "4px solid #f4f5f7",
          padding: "16px",
        }}
      >
        <div
          className="d-flex align-items-center sec-title"
          style={{ marginBottom: "16px" }}
        >
          <img
            src={bagIcon}
            alt="titleImg"
            style={{ width: "16px", minWidth: "16px", marginRight: "12px" }}
          />
          <h2 style={{ margin: "0" }}>Order Summary</h2>
        </div>
        <ul className="billSummaryList">
          {order?.suborder.map((element, index) => (
            <li
              key={element?.product_name + index}
              style={{ fontWeight: "600" }}
            >
              {element.qty} x {element?.product_name}
              <div className="ms-auto" style={{ color: "#666" }}>
                ₹{element?.sp}
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div
        className="card-wrap"
        style={{
          background: "#fff",
          borderBottom: "4px solid #f4f5f7",
          padding: "16px",
        }}
      >
        <div
          className="d-flex align-items-center sec-title"
          style={{ marginBottom: "16px" }}
        >
          <img
            src={billIcon}
            alt="titleImg"
            style={{ width: "18px", minWidth: "18px", marginRight: "12px" }}
          />
          <h2 style={{ margin: "0" }}>Bill Summary</h2>
        </div>
        <ul className="billSummaryList">
          <li style={{ fontWeight: "600" }}>
            Item Total({order?.suborder?.length} items){" "}
            <div className="ms-auto" style={{ color: "#666" }}>
              ₹{order?.order?.order_mrp}
            </div>
          </li>
          <li>
            Packaging Fees{" "}
            <div className="badge badge-success ms-auto">Free</div>
          </li>
          <li>
            Delivery Fees{" "}
            <div className="badge badge-success ms-auto">Free</div>
          </li>
          <li className="list-subtotal">
            SUB TOTAL:{" "}
            <div className="ms-auto">₹{order?.order?.order_total}</div>
          </li>
        </ul>
      </div>

      <CustomerCare showHelp={showHelp} setShowHelp={setShowHelp} />
    </div>
  ) : null;
};

export default PlacedOrderDetails;
